<template>
    <div v-if="site" class="site-data-panel v-flex">
        <p-site-tzb-calculation
            v-if     = "tzb"
            v-model  = "showTzbCalculation"
            :unit-id = "site.id"
            :tzb     = "tzb"
        />

        <t-site-menu
            :key     = "refreshMenu"
            :edit    = "edit"
            :history = "tab === 2"
            :history-editable="tab === 2 && isEscalator"
            :reports = "tab === 2"
            :condition="tab === 2 && site.customer.extendedConditions && this.isElevator"
            :download= "(site.liftmanagement && tab === 8) || (!site.liftmanagement && tab === 7)"
            v-if     = "menuTabs.includes (realTab)"
            @readonly= "onReadonly"
            @save    = "onSave"
            @close   = "onClose"
            @refresh = "onRefresh"
            @history = "onHistory"
            @reports = "onReports"
            @extended-conditions = "onExtendedConditions"
            ref      = "menu"
        />

        <div
            v-if = "!menuTabs.includes (realTab)"
            style="margin-left: 75px;"
        >
        </div>

        <v-tabs
            v-model      = "tab"
            class        = "folder-tabs ml-0 pr-0 mr-0"
            active-class = "folder-tab-active primary"
            height       = "40"
            style="max-width: calc(100% - 75px);"
            show-arrows
        >
            <v-tabs-slider color="primary"></v-tabs-slider>
            <v-tab
                class = "folder-tab"
                :key  = "1"
            >
                <span><v-icon size="20">{{  readonly ? 'mdi-eye-outline' : 'mdi-pen' }}</v-icon></span>
                <span class="pl-2">Anlage</span>
            </v-tab>

            <v-tab
                class = "folder-tab"
                :key  = "2"
            >
                <span><v-icon size="20">{{  readonly ? 'mdi-eye-outline' : 'mdi-pen' }}</v-icon></span>
                <span class="pl-2">Spezifikation</span>
            </v-tab>

            <v-tab
                class = "folder-tab"
                :key  = "3"
            >
                <div class="v-flex">
                    <div class="mr-2">
                        TZB
                    </div>
                    <c-site-tzb-rating
                        v-if="tzb && tzb.rating"
                        class   = "rating-tab"
                        :color  = "tab === 2 ? 'white' : 'primary'"
                        v-model = "tzb.rating"
                    />
                </div>
            </v-tab>

            <v-tab
                class = "folder-tab"
                :key  = "4"
            >
                GBU / ESG
            </v-tab>

            <v-tab
                class = "folder-tab"
                :key  = "5"
            >
                Kontakte
            </v-tab>

            <v-tab
                class = "folder-tab"
                :key  = "6"
            >
                Adressen
            </v-tab>

            <v-tab
                class = "folder-tab"
                :key  = "7"
                v-if  = "site.liftmanagement"
            >
                Vertragsdaten
            </v-tab>
            <v-tab
                class = "folder-tab"
                :key  = "8"
            >
                <span><v-icon size="20">{{  readonly ? 'mdi-eye-outline' : 'mdi-pen' }}</v-icon></span>
                <span class="pl-2">Notizen</span>
            </v-tab>

            <v-tab
                class = "folder-tab"
                :key  = "9"
            >
                Bilder
            </v-tab>

            <v-tab
                class = "folder-tab"
                :key  = "10"
            >
                <span><v-icon size="20">{{  readonly ? 'mdi-eye-outline' : 'mdi-pen' }}</v-icon></span>
                <span class="pl-2">Wartungen</span>
            </v-tab>

            <v-tab
                class = "folder-tab"
                :key  = "11"
            >
                ZÜS Prüfungen
            </v-tab>
            <v-tab
                class = "folder-tab"
                :key  = "12"
            >
                Dokumente
            </v-tab>

            <v-tabs-items v-model="tab">
                <v-tab-item :key="1">
                    <t-site-core
                        :site     = "site"
                        :readonly = "readonly"
                        ref       = "corePage"
                        @saved    = "onSaved"
                        @customer = "onCustomer"
                    />
                 </v-tab-item>

                <v-tab-item
                    v-if="isElevator || isEscalator"
                    :key="2"
                >
                    <t-site-specification-elevator
                        v-if      = "isElevator"
                        :site-id  = "site.id"
                        :spec     = "site.specification"
                        :tzb      = "tzb"
                        :readonly = "readonly"
                        ref       = "pageElevator"
                        @type     = "onType"

                    />
                    <t-site-specification-escalator
                        v-if      = "isEscalator"
                        :site-id  = "site.id"
                        :spec     = "site.specification"
                        :tzb      = "tzb"
                        :readonly = "readonly"
                        ref       = "pageEscalator"
                        @type     = "onType"
                    />
                </v-tab-item>

                <v-tab-item
                    v-if="!isElevator && !isEscalator"
                    :key="2"
                >
                    <!-- type only, e.g. doors and gates; the office resolves type conflicts here (HCIT-943) -->
                    <t-site-type
                        :site     = "site"
                        :readonly = "readonly"
                        @type     = "onType"
                    />
                </v-tab-item>

                <v-tab-item :key="3">
                    <t-site-tzb-elevator
                        v-if  = "isElevator"
                        :site = "site"
                        :readonly = "readonly"
                        ref   = "pageTzbElevator"
                    />
                    <t-site-tzb-escalator
                        v-if      = "isEscalator"
                        :site     = "site"
                        :readonly = "readonly"
                        ref       = "pageTzbEscalator"
                        @saved    = "onTzbSaved"
                    />
                </v-tab-item>

                <!--
                <v-tab-item :key="3" v-if="!site.tzb">
                    <div class="missing-data">
                        Kein TZB vorhanden
                    </div>
                </v-tab-item>
                -->

                <v-tab-item :key="4">
                    <c-audits
                        :unit = "site"
                        ref   = "pageAudit"
                    />
                </v-tab-item>

                 <v-tab-item
                    :key="5"
                >
                     <v-card flat>
                         <t-site-contacts
                             :site = "site"
                             ref   = "page"
                         />
                     </v-card>
                </v-tab-item>

                <v-tab-item
                    :key="6"
                >
                    <v-card flat>
                        <t-site-recipients
                            :site = "site"
                            ref   = "page"
                        />
                    </v-card>
                </v-tab-item>

                <v-tab-item
                    :key="7"
                    v-if="site.liftmanagement"
                >
                    <v-card flat>
                        <t-site-contracts
                            :site     = "site"
                            ref       = "page"
                        />
                    </v-card>
                </v-tab-item>

                <v-tab-item
                    :key="8"
                >
                    <v-card flat>
                        <t-site-notes
                            :site-id  = "site.id"
                            :notes    = "site.notes"
                            :readonly = "readonly"
                            ref       = "pageNotes"
                        />
                    </v-card>
                </v-tab-item>

                <v-tab-item
                    :key="9"
                >
                    <v-card flat>
                        <img-site-images
                            :site = "site"
                        />
                    </v-card>
                </v-tab-item>

                 <v-tab-item
                    :key="10"
                >
                    <v-card flat>
                        <t-site-maintenance
                            :site     = "site"
                            :readonly = "readonly"
                            ref       = "page"
                        />
                    </v-card>
                </v-tab-item>
                <v-tab-item
                    :key="11"
                >
                    <v-card flat>
                        <t-site-assessment
                            :site     = "site"
                            :readonly = "readonly"
                            ref       = "page"
                        />
                    </v-card>
                </v-tab-item>

                <v-tab-item
                    :key="12"
                >
                    <v-card flat>
                        <t-site-documents
                            :site = "site"
                        />
                    </v-card>
                </v-tab-item>
            </v-tabs-items>
        </v-tabs>
    </div>
</template>

<script>

import Core                        from "@/modules/core/service/Core";
import Site                        from "@/modules/msd/unit/service/Site";
import TSiteCore                   from "@/modules/msd/unit/components/dialog/TSiteCore";
import TSiteSpecificationEscalator from "@/modules/msd/unit/components/dialog/TSiteSpecificationEscalator";
import TSiteType from "@/modules/msd/unit/components/dialog/TSiteType.vue";
import TSiteSpecificationElevator  from "@/modules/msd/unit/components/dialog/TSiteSpecificationElevator";
import TSiteTzbElevator            from "@/modules/msd/unit/components/dialog/TSiteTzbElevator";
import TSiteTzbEscalator           from "@/modules/msd/unit/components/dialog/TSiteTzbEscalator";
import TSiteNotes                  from "@/modules/msd/unit/components/dialog/TSiteNotes";
import TSiteContracts              from "@/modules/msd/unit/components/dialog/TSiteContracts.vue";
import CSiteTzbRating              from "@/modules/msd/unit/components/dialog/CSiteTzbRating";
import TSiteMenu                   from "@/modules/msd/unit/components/dialog/TSiteMenu";
import TSiteContacts               from "@/modules/msd/unit/components/dialog/TSiteContacts";
import ImgSiteImages               from "@/modules/img/components/main/ImgSiteImages";
import TSiteRecipients             from "@/modules/msd/unit/components/dialog/TSiteRecipients";
import TSiteMaintenance            from "@/modules/msd/unit/components/dialog/TSiteMaintenance";
import TSiteAssessment             from "@/modules/msd/unit/components/dialog/TSiteAssessment";
import TSiteDocuments              from "@/modules/msd/unit/components/dialog/TSiteDocuments";
import CAudits                     from "@/modules/audit/components/CAudits.vue";
import PSiteTzbCalculation         from "@/modules/msd/unit/components/dialog/private/PSiteTzbCalculation.vue";

export default {
    name: "TSite",

    components: {
        PSiteTzbCalculation,
        CAudits,
        TSiteDocuments,
        TSiteAssessment,
        TSiteMaintenance,
        TSiteRecipients,
        ImgSiteImages,
        TSiteContacts,
        TSiteMenu,
        CSiteTzbRating,
        TSiteContracts,
        TSiteNotes,
        TSiteTzbElevator,
        TSiteTzbEscalator,
        TSiteSpecificationEscalator,
        TSiteType,
        TSiteSpecificationElevator,
        TSiteCore
    },

    props: {
        site: {
            required: false,
            type    : Object,
            default : function () {
                return {
                    specification: null,
                }
            }
        },

        tabIndex: {
            required: false,
            type    : Number,
            default : function () {
                return null;
            }
        },
    },

    data: () => ({
        tab     : 0,
        readonly: true,
        edit: false,
        refreshMenu: 0,
        tzb: null,
        showTzbCalculation: false,
        menuTabs: [ 0, 1, 2, 7, 8],
    }),

    computed: {
        isElevator () {
            return Site.isElevator(this.site);
        },

        isEscalator () {
            return Site.isEscalator(this.site);
        },

        realTab () {
            if (this.site.liftmanagement || this.tab < 6) {
                return this.tab;
            }

            return this.tab + 1;
        },
    },

    watch: {
        site () {
            this.edit = false;
            this.readonly = !this.edit;
            this.tab = this.tabIndex;
            if (this.site) {
                Site.condition.loadCurrent(this.site).then(tzb => {
                    this.tzb = tzb;
                });
            } else {
                this.tzb = null;
            }
        },
        tab () {
            console.log("tab", this.tab)
        }
    },

    methods: {
        reset () {
            this.tab = 0;
        },

        onReadonly (readonly) {
            this.readonly = readonly;
            this.edit = !readonly;
        },

        onSave () {
            switch (this.tab) {
                case 0:
                    this.$refs.corePage.onSave();
                    break;
                case 1:
                    if (this.isElevator) {
                        this.$refs.pageElevator.onSave ();
                    }
                    if (this.isEscalator) {
                        this.$refs.pageEscalator.onSave ();
                    }

                    this.$nextTick(() => {
                        this.readonly = true;
                        this.edit = false;
                    });
                    break;
                case 2:
                    // notes of the escalator TZB (HCIT-937); the elevator TZB is not edited here
                    if (this.isEscalator) {
                        // the edit mode stays open if the notes could not be saved
                        this.$refs.pageTzbEscalator.onSave().then(saved => {
                            if (saved) {
                                this.readonly = true;
                                this.edit = false;
                            }
                        });
                    }
                    break;
                case 6:
                    if (!this.site.liftmanagement) {
                        this.$refs.pageNotes.onSave();
                    }
                    break;
                case 7:
                    this.$refs.pageNotes.onSave();
                    break;
            }
        },

        onType (event) {
            this.$emit("type", event)
        },

        /** The current TZB of the dialog (rating in the tab, calculation) after the escalator notes were saved. */
        onTzbSaved () {
            Site.condition.loadCurrent(this.site).then(tzb => {
                this.tzb = tzb;
            });
        },

        onClose () {
            this.$emit("close");
        },

        onRefresh () {
            this.$emit("refresh");
        },

        onHistory () {
            switch (this.tab) {
                case 2:
                    if (this.isElevator) {
                        this.$refs.pageTzbElevator.onHistory();
                    }
                    if (this.isEscalator) {
                        this.$refs.pageTzbEscalator.onHistory();
                    }
                    break;
            }
        },

        onReports () {
            switch (this.tab) {
                case 2:
                    if (this.isElevator) {
                        this.$refs.pageTzbElevator.onReports();
                    }
                    if (this.isEscalator) {
                        this.$refs.pageTzbEscalator.onReports();
                    }
                    break;
            }
        },

        onExtendedConditions () {
            this.showTzbCalculation = true;
        },

        onSaved (data) {
            this.readonly = true;
            this.refreshMenu ++;
            Core.fire.saved(this, data);
        },

        onCustomer () {
            this.$emit("customer");
        },
    }
}
</script>

<style scoped>

.site-data-panel {
    height: 890px;
    min-height: 890px;
}

::v-deep .theme--light.v-tabs>.v-tabs-bar {
    border-bottom-style: solid;
    border-bottom-width: 1px;
    border-bottom-color: lightgray;
}

.rating-tab {
    padding: 2px 5px 3px;
    border-radius: 3px;
}

.folder-tab {
    width: 138px;
}

.missing-data {
    font-size: 40px;
    text-align: center;
    color: lightgray;
    margin-top: 100px;
}


</style>